import { Divider, Typography, useMediaQuery } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../stores/hooks';
import { getGraphCards } from '../../../util/graphCards';
import { useStyles } from './InformationCardsMUI';

export const InformationCards = () => {
  const classes = useStyles();
  const matches1000 = useMediaQuery('(max-width: 1000px)');
  const matches650 = useMediaQuery('(max-width: 650px)');

  const totalGenomes = useAppSelector(state => state.dashboard.totalGenomes);
  const actualGenomes = useAppSelector(state => state.dashboard.actualGenomes);
  const totalGenotypes = useAppSelector(state => state.dashboard.totalGenotypes);
  const actualGenotypes = useAppSelector(state => state.dashboard.actualGenotypes);
  const organism = useAppSelector(state => state.dashboard.organism);
  const { t } = useTranslation();
  const graphCards = useMemo(() => getGraphCards(t), [t]);

  const totalLabelKey = useMemo(() => {
    const stOrganisms = ['kpneumo', 'shige', 'decoli', 'ecoli', 'senterica'];
    if (stOrganisms.includes(organism)) {
      return 'informationCards.totalSTs';
    }
    const lineageCard = graphCards.find(card => card.title.toLowerCase().includes('lineage'));
    const STCard = graphCards.find(card => card.title.toLowerCase().includes('st'));

    if (lineageCard?.organisms?.includes(organism)) {
      return 'informationCards.totalLineages';
    }
    if (STCard?.organisms?.includes(organism)) {
      return 'informationCards.totalSTs';
    }
    return 'informationCards.totalGenotypes';
  }, [organism]);

  const totalLabel = t(totalLabelKey);

  return (
    <div className={classes.cardsWrapper}>
      <div className={classes.card}>
        <div className={classes.cardContent}>
          <Typography variant={matches650 ? 'body2' : 'body1'} component="div" className={classes.title}>
            {`${t('informationCards.totalGenomes')}${matches1000 ? ':' : ''}`}
          </Typography>
          <Typography variant={matches650 ? 'h6' : 'h5'} sx={{ fontWeight: '500' }}>
            {totalGenomes === actualGenomes ? (
              <>{totalGenomes}</>
            ) : (
              <span className={classes.actualAndTotalValues}>
                {actualGenomes}
                <Typography variant={matches650 ? 'body2' : 'body1'} sx={{ fontWeight: '500' }}>
                  /{totalGenomes}
                </Typography>
              </span>
            )}
          </Typography>
        </div>
      </div>
      {!matches650 && <Divider orientation="vertical" flexItem />}
      <div className={classes.card}>
        <div className={classes.cardContent}>
          <Typography variant={matches650 ? 'body2' : 'body1'} component="div" className={classes.title}>
            {`${totalLabel}${matches1000 ? ':' : ''}`}
          </Typography>
          <Typography variant={matches650 ? 'h6' : 'h5'} sx={{ fontWeight: '500' }} className={classes.titleCount}>
            {totalGenotypes === actualGenotypes ? (
              <>{totalGenotypes}</>
            ) : (
              <span className={classes.actualAndTotalValues}>
                {actualGenotypes}
                <Typography variant={matches650 ? 'body2' : 'body1'} sx={{ fontWeight: '500' }}>
                  /{totalGenotypes}
                </Typography>
              </span>
            )}
          </Typography>
        </div>
      </div>
    </div>
  );
};
